(() => {
  const initialize = () => {
    document.querySelectorAll('[data-whd]').forEach(root => {
      if (root.dataset.whdReady) return;
      root.dataset.whdReady = 'true';
      const desktop = window.matchMedia('(min-width: 768px)');
      const hover = window.matchMedia('(hover: hover) and (pointer: fine)');
      const triggers = [...root.querySelectorAll('[data-whd-trigger]')];
      let active = null;
      let enterTimer;
      let leaveTimer;
      const panelFor = button => document.getElementById(button.getAttribute('aria-controls'));
      const position = () => {
        if (!active) return;
        const bar = root.getBoundingClientRect();
        if (bar.bottom <= 0 || bar.top >= window.innerHeight) { close(); return; }
        root.style.setProperty('--whd-top', `${Math.max(0, Math.round(bar.bottom))}px`);
      };
      const close = (restore = false) => {
        clearTimeout(enterTimer);
        clearTimeout(leaveTimer);
        if (!active) return;
        const previous = active;
        panelFor(previous).hidden = true;
        previous.setAttribute('aria-expanded', 'false');
        active = null;
        if (restore) previous.focus();
      };
      const open = button => {
        if (!desktop.matches) return;
        clearTimeout(enterTimer);
        clearTimeout(leaveTimer);
        if (active === button) return;
        close();
        active = button;
        position();
        panelFor(button).hidden = false;
        button.setAttribute('aria-expanded', 'true');
      };
      triggers.forEach(button => {
        const panel = panelFor(button);
        button.addEventListener('click', () => active === button ? close() : open(button));
        button.addEventListener('pointerenter', () => {
          if (!hover.matches) return;
          clearTimeout(leaveTimer);
          clearTimeout(enterTimer);
          enterTimer = setTimeout(() => open(button), 90);
        });
        button.addEventListener('keydown', event => {
          if (event.key === 'ArrowDown') { event.preventDefault(); open(button); panel.querySelector('a')?.focus(); }
        });
        panel.addEventListener('pointerenter', () => { clearTimeout(leaveTimer); clearTimeout(enterTimer); });
        const leave = event => {
          if (!hover.matches || root.contains(event.relatedTarget)) return;
          clearTimeout(enterTimer);
          leaveTimer = setTimeout(() => close(), 160);
        };
        panel.addEventListener('pointerleave', leave);
      });
      root.addEventListener('pointerleave', event => {
        if (!hover.matches || root.contains(event.relatedTarget)) return;
        clearTimeout(enterTimer);
        leaveTimer = setTimeout(() => close(), 160);
      });
      root.querySelectorAll('.whd__direct').forEach(link => link.addEventListener('pointerenter', () => { if (hover.matches) close(); }));
      root.addEventListener('keydown', event => { if (event.key === 'Escape' && active) { event.preventDefault(); close(true); } });
      root.addEventListener('focusout', event => { if (!root.contains(event.relatedTarget)) close(); });
      document.addEventListener('pointerdown', event => { if (!root.contains(event.target)) close(); });
      window.addEventListener('scroll', position, { passive: true });
      window.addEventListener('resize', position, { passive: true });
      desktop.addEventListener('change', () => close());
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
